function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as t, jsxs as g } from "react/jsx-runtime";
import * as m from "react";
import S from "classnames";
import { BaseTouchable as $ } from "./touchable.js";
import v from "./responsive-layout.js";
import { useTheme as R, useAriaId as w, useElementDimensions as k } from "./hooks.js";
import { Text as x } from "./text.js";
import { isRunningAcceptanceTest as I } from "./utils/platform.js";
import { getPrefixedDataAttributes as z } from "./utils/dom.js";
import { outerBorder as H, outer as P, inner as W, tabsContainer as B, tabVariants as D, tabSelectionVariants as f, icon as V, animatedLine as _ } from "./tabs.css-mistica.js";
import j from "./inline.js";
const d = I() ? 0 : 300, q = (i)=>{
    switch(i){
        case 1:
        case 2:
        case 3:
            return "fullWidth";
        default:
            return "default";
    }
}, C = (param)=>{
    let { selectedIndex: i , onChange: y , tabs: u , dataAttributes: T  } = param;
    const { textPresets: r  } = R(), l = w(), { ref: A  } = k(), b = m.useRef(null), h = m.useRef(null), [p, L] = m.useState(!1), N = (o, c)=>{
        const s = document.querySelector(`[id='${l}'] [data-tabindex="${o}"]`), n = document.querySelector(`[id='${l}'] [data-tabindex="${c}"]`), e = b.current, a = h.current;
        s && n && e && a && (L(!0), e.style.display = "block", e.style.width = `${s.offsetWidth}px`, e.style.transform = `translate(${s.offsetLeft - a.scrollLeft}px, 0)`, Promise.resolve().then(()=>{
            e.style.transition = `transform ${d}ms, width ${d}ms`, e.style.width = `${n.offsetWidth}px`, e.style.transform = `translate(${n.offsetLeft - a.scrollLeft}px, 0)`;
        }), setTimeout(()=>{
            e.style.transition = "", e.style.display = "none", L(!1);
        }, d));
    };
    return /* @__PURE__ */ t("div", _object_spread_props(_object_spread({
        id: l,
        role: "tablist",
        ref: A,
        className: H
    }, z(T, "Tabs")), {
        children: /* @__PURE__ */ t(v, {
            fullWidth: !0,
            children: /* @__PURE__ */ g("div", {
                className: P,
                children: [
                    /* @__PURE__ */ t("div", {
                        ref: h,
                        className: W,
                        children: /* @__PURE__ */ t("div", {
                            className: B,
                            children: u.map((param, e)=>{
                                let { text: o , trackingEvent: c , icon: s , "aria-controls": n  } = param;
                                const a = e === i;
                                return /* @__PURE__ */ t($, {
                                    dataAttributes: {
                                        "component-name": "Tab",
                                        tabindex: e
                                    },
                                    className: S(D[q(u.length)], a ? p ? f.selectedAnimating : f.selected : f.noSelected),
                                    onPress: ()=>{
                                        !p && i !== e && (y(e), N(i, e));
                                    },
                                    trackingEvent: c,
                                    role: "tab",
                                    "aria-controls": n,
                                    "aria-selected": a ? "true" : "false",
                                    children: /* @__PURE__ */ g(j, {
                                        space: s && o ? 8 : 0,
                                        alignItems: "center",
                                        children: [
                                            s && /* @__PURE__ */ t("div", {
                                                className: V,
                                                children: s
                                            }),
                                            /* @__PURE__ */ t(x, {
                                                desktopSize: r.tabsLabel.size.desktop,
                                                mobileSize: r.tabsLabel.size.mobile,
                                                desktopLineHeight: r.tabsLabel.lineHeight.desktop,
                                                mobileLineHeight: r.tabsLabel.lineHeight.mobile,
                                                weight: r.tabsLabel.weight,
                                                color: "inherit",
                                                wordBreak: !1,
                                                textAlign: "center",
                                                hyphens: "auto",
                                                children: o
                                            })
                                        ]
                                    })
                                }, e);
                            })
                        })
                    }),
                    /* @__PURE__ */ t("div", {
                        ref: b,
                        className: _
                    })
                ]
            })
        })
    }));
}, Y = C;
export { Y as default };
